import { FormBase } from 'core/components';

export default class ImportItemGroupEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'billableToMedicare',
                    label: 'IMPORT.EDIT.BILLABLE_TO_MEDICARE',
                    type: 'checkbox'
                },
                {
                    name: 'diagnosisCode1',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_1_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_1_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'woundLocation',
                    label: 'IMPORT.EDIT.WOUND_LOCATION_LABEL',
                    placeholder: 'IMPORT.EDIT.WOUND_LOCATION_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'secondaryVerified',
                    label: 'IMPORT.EDIT.SECONDARY_VERIFIED_LABEL',
                    placeholder: 'IMPORT.EDIT.SECONDARY_VERIFIED_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode2',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_2_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_2_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode3',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_3_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_3_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode4',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_4_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_4_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode5',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_5_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_5_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode6',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_6_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_6_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode7',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_7_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_7_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'diagnosisCode8',
                    label: 'IMPORT.EDIT.DIAGNOSIS_CODE_8_LABEL',
                    placeholder: 'IMPORT.EDIT.DIAGNOSIS_CODE_8_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'salesOrderNote',
                    label: 'IMPORT.EDIT.SALES_ORDER_NOTE_LABEL',
                    placeholder: 'IMPORT.EDIT.SALES_ORDER_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'reference',
                    label: 'IMPORT.EDIT.REFERENCE_LABEL',
                    placeholder: 'IMPORT.EDIT.REFERENCE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'referenceList',
                    label: 'IMPORT.EDIT.REFERENCE_LIST_LABEL',
                    placeholder: 'IMPORT.EDIT.REFERENCE_LIST_PLACEHOLDER'
                }
            ],
        };
    }
}
